class UnderstandSectionEntity {
    constructor(
    //reportSummary: Array<IUnderstandSectionSubEntity>,
    reportDetails) {
        //this.reportSummary = reportSummary;
        this.reportDetails = reportDetails;
    }
}
export default UnderstandSectionEntity;
